import { type ADDRESS_KIND_VALUES, UF_VALUES } from '@aeris/contracts'

/**
 * Os valores de um endereço em edição — F089, F130.
 *
 * Separados de `components/address-inputs.tsx` porque um arquivo de componente
 * que exporta também constantes perde o recarregamento rápido do Vite. Usados
 * pela ficha da pessoa e pelo "Novo cadastro".
 */

export type AddressValues = {
  kind: (typeof ADDRESS_KIND_VALUES)[number]
  cep: string
  street: string
  number: string
  complement: string
  district: string
  city: string
  ibgeCode: string
  uf: (typeof UF_VALUES)[number]
  country: string
  isMain: boolean
}

export const EMPTY_ADDRESS: AddressValues = {
  kind: 'other',
  cep: '',
  street: '',
  number: '',
  complement: '',
  district: '',
  city: '',
  ibgeCode: '',
  uf: 'SP',
  country: 'BR',
  isMain: false,
}

/** Uma sigla que veio de fora, conferida contra a lista fechada. */
export const ufOrNull = (value: string): AddressValues['uf'] | null =>
  (UF_VALUES as readonly string[]).includes(value)
    ? (value as AddressValues['uf'])
    : null
